/**
 * Селект «Заявка принадлежит менеджеру» — только для роли ASSISTANT (Помощник).
 * Помощник обязан выбрать владельца заявки из прикреплённых менеджеров,
 * себя выбрать не может (заявки помощника не существуют — KPI идёт менеджеру).
 */
export function AssistantOwnerSelect({
  value,
  managers,
  onChange,
}: {
  value: string
  managers: { id: string; name: string | null; email: string }[]
  onChange: (managerId: string) => void
}) {
  return (
    <div className="max-w-md">
      <label className="block text-xs text-gray-500 mb-1">
        Заявка принадлежит менеджеру <span className="text-red-500">*</span>
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-2 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 bg-white"
      >
        <option value="" disabled>
          Выберите менеджера…
        </option>
        {managers.map((m) => (
          <option key={m.id} value={m.id}>
            {m.name || m.email}
          </option>
        ))}
      </select>
      {managers.length === 0 && (
        <p className="text-xs text-red-500 mt-1">
          Вы не прикреплены ни к одному менеджеру — создание заявки недоступно. Обратитесь к
          администратору.
        </p>
      )}
    </div>
  )
}
